import Ensure from "../Base/Ensure";
import NSDictionary from "../Base/NSDictionary";
import NSSet from "../Base/NSSet";
import NSIdentity from "../Base/NSIdentity";
import IdResolver from "../Base/IdResolver";
import GrimoireInterface from "../Interface/GrimoireInterface";
export default class NodeDeclaration {
    constructor(name, _defaultComponents, _defaultAttributes, _superNode, _freezeAttributes = []) {
        this.name = name;
        this._defaultComponents = _defaultComponents;
        this._defaultAttributes = _defaultAttributes;
        this._superNode = _superNode;
        this._freezeAttributes = _freezeAttributes;
        this.defaultAttributes = new NSDictionary();
        this.idResolver = new IdResolver();
        this._resolvedDependency = false;
        if (!this._superNode && this.name.name !== "grimoire-node-base") {
            this._superNode = new NSIdentity("grimoirejs.grimoire-node-base");
        }
        this._freezeAttributes = this._freezeAttributes || [];
    }
    get resolvedDependency() {
        return this._resolvedDependency;
    }
    get defaultComponentsActual() {
        if (!this._resolvedDependency) {
            throw new Error(`${this.name.fqn} is not resolved dependency!`);
        }
        return this._defaultComponentsActual;
    }
    get defaultAttributesActual() {
        if (!this._resolvedDependency) {
            throw new Error(`${this.name.fqn} is not resolved dependency!`);
        }
        return this._defaultAttributesActual;
    }
    addDefaultComponent(componentName) {
        const componentId = Ensure.tobeNSIdentity(componentName);
        this.defaultComponents.push(componentId);
        if (this._defaultComponentsActual) {
            this._defaultComponentsActual.push(componentId);
        }
    }
    /**
     * resolve requiredComponents,superNode,defaults and freezeAttributes,
     * throw error if they have any ambiguity.
     * デフォルトコンポーネント、スーパノード、デフォルト値、フリーズ値の名前解決。曖昧は例外
     */
    resolveDependency() {
        if (this._resolvedDependency) {
            return false;
        }
        this.defaultComponents = new NSSet(this._defaultComponents.map(name => Ensure.tobeNSIdentity(name)));
        for (let key in this._defaultAttributes) {
            let value = this._defaultAttributes[key];
            this.defaultAttributes.set(NSIdentity.fromFQN(key), value);
        }
        this.superNode = this._superNode ? Ensure.tobeNSIdentity(this._superNode) : void 0;
        this._resolveInherites();
        this._defaultComponentsActual.forEach(id => {
            const dec = GrimoireInterface.componentDeclarations.get(id);
            dec.idResolver.foreach(fqn => {
                this.idResolver.add(NSIdentity.fromFQN(fqn));
            });
        });
        this.freezeAttributes = new NSSet(this._freezeAttributes.map(name => Ensure.tobeNSIdentity(name)));
        this._resolvedDependency = true;
        return true;
    }
    _resolveInherites() {
        if (!this.superNode) {
            this._defaultComponentsActual = this.defaultComponents;
            this._defaultAttributesActual = this.defaultAttributes;
            return;
        }
        const superNode = GrimoireInterface.nodeDeclarations.get(this.superNode);
        superNode.resolveDependency();
        const inheritedDefaultComponents = superNode.defaultComponentsActual;
        const inheritedDefaultAttribute = superNode.defaultAttributesActual;
        this._defaultComponentsActual = inheritedDefaultComponents.clone().merge(this.defaultComponents);
        this._defaultAttributesActual = inheritedDefaultAttribute.clone().pushDictionary(this.defaultAttributes);
    }
}



// WEBPACK FOOTER //
// ./src/Node/NodeDeclaration.ts